import { createContext, useContext } from 'react';

/**
 * Context for print mode to pass down to all chart components.
 * This allows charts to switch between responsive sizing (screen) and fixed pixel sizing (print).
 * 
 * When isPrintMode is true:
 * - ReCharts ResponsiveContainer should use fixed pixel dimensions (680px full-width, 330px half-width for A4)
 * - Animations should be disabled with isAnimationActive={false}
 * 
 * @see ITReport.jsx for the provider implementation with beforeprint/afterprint event handlers
 */
export const PrintModeContext = createContext(false);

/**
 * Hook to access print mode state in chart components.
 * @returns {boolean} isPrintMode - true when preparing for or actively printing
 */
export const usePrintMode = () => useContext(PrintModeContext);
